import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ProjectTabsService } from '../../../services/project-tabs.service';

@Component({
  selector: 'project-tab-content',
  templateUrl: './project-tab-content.component.html',
  styleUrls: ['./project-tab-content.component.scss'],
})
export class ProjectTabContentComponent implements OnInit, OnDestroy {
  @ViewChild('projectTabContent', { read: ViewContainerRef, static: true })
  target: ViewContainerRef;

  constructor(public projectTabsService: ProjectTabsService) {}

  ngOnInit() {
    this.projectTabsService.initializeTabsContent(this.target);
  }

  ngOnDestroy() {
    this.target.clear();
  }
}
